import React from "react";
import './quotes-title.scss';
import Parser from "../../../common/content-parser/content-parser";
// import BarChart from "../../bar-chart/bar-chart";
import BarChart from "../../bar-chart-v2/bar-chart";
import { PieChart } from "recharts";
import MyPieChart from "./pie-chart/pie.chart";

class AssessmentQuote extends React.Component {

    state = {
        totalActiveClickers: 0,
        caseStudySkillList: [
            // {
            //     title: 'Unable to understand the question',
            //     incorrectCount: 10,
            //     colour: '#6B52C8',
            //     name: 'Unable to understand the question',
            //     value: 10
            // },
            // {
            //     title: 'Unable to apply the right strategy / Concept',
            //     incorrectCount: 10,
            //     colour: '#FF9501',
            //     name: 'Unable to apply the right strategy / Concept',
            //     value: 10
            // },
            // {
            //     title: 'Unable to Calculate',
            //     incorrectCount: 10,
            //     colour: '#FFC928',
            //     name: 'Unable to Calculate',
            //     value: 10
            // }
        ]
    }

    constructor(props) {
        super(props);
        this.parser = new Parser();
        // this.label = this.props.quote.replace(/^(<p>(\s|&nbsp;)*<\/p>)*/, "");
        // this.label = this.label.replace(/(<p>(\s|&nbsp;)*<\/p>)*$/, "");


    }

    componentDidMount() {
        // let userIds = []

        // this.props.studentList.map(item => {
        //     if (!item.isTeacher && item.userDeviceMacId.length === 17) {
        //         userIds.push(item.userId)
        //     }
        // })

        // let totalActiveClickers = userIds.length

        // this.setState({ totalActiveClickers })

        console.log(this.props.options)

        if (this.props.isMultiStep) {
            let caseStudySkillList = [];

            ['Comprehension', 'Modelling', 'Calculation'].forEach(skill => {

                if (this.props.caseStudySkillHash[skill]) {
                    let skillItem = this.props.caseStudySkillHash[skill]
                    if (skill === 'Comprehension') {
                        skillItem.title = 'Unable to understand the question'
                        skillItem.colour = '#6B52C8'
                        skillItem.name = 'Unable to understand the question'
                        skillItem.value = skillItem.incorrectCount
                    }

                    if (skill === 'Modelling') {
                        skillItem.title = 'Unable to apply the right strategy / Concept'
                        skillItem.colour = '#FF9501'
                        skillItem.name = 'Unable to apply the right strategy / Concept'
                        skillItem.value = skillItem.incorrectCount
                    }

                    if (skill === 'Calculation') {
                        skillItem.title = 'Unable to Calculate'
                        skillItem.colour = '#FFC928'
                        skillItem.name = 'Unable to Calculate'
                        skillItem.value = skillItem.incorrectCount
                    }

                    caseStudySkillList.push(skillItem)
                }
            })

            this.setState({ caseStudySkillList })
        }
    }


    render() {
        let styles = {
            p: { fontSize: '28px', fontFamily: "Mont", fontStyle: 'normal', fontWeight: "700" }
        }
        return (

            <>

                {
                    !this.props.isMultiStep ?
                        <div className="quotes-title-for-practice-flow" style={{
                            marginLeft: `${this.props.isFullScreenMode && this.props.showStudentResponse ? '2.5rem' :
                                this.props.isFullScreenMode && !this.props.showStudentResponse ? "2.5rem" : this.props.showStudentResponse ? "6rem" : '0rem'}`
                        }}>

                            <div className="d-flex justify-content-start">
                                <BarChart options={this.props.options} 
                                studentResponseCount={this.props.studentResponseCount} 
                                totalStudentsCount = {this.props.studentList.length - 1}
                                />
                            </div>
                        </div>
                        :
                        <div className="quotes-title-for-practice-flow mt-5" style={{
                            marginLeft: `${this.props.isFullScreenMode && this.props.showStudentResponse ? '2.5rem' :
                                this.props.isFullScreenMode && !this.props.showStudentResponse ? "2.5rem" : this.props.showStudentResponse ? "6rem" : '0rem'}`
                        }}>

                            <div className="d-flex">
                                <BarChart options={this.props.options} studentResponseCount={this.props.studentResponseCount}  />
                                <div className="analytical-report ml-5">
                                    <div className="title mb-2">Responses Analysis</div>
                                    <div className="skill-wrapper">
                                        {
                                            this.state.caseStudySkillList.length ?
                                                this.state.caseStudySkillList.map(item => (
                                                    <div className="row mb-2">
                                                        <div className="col d-flex align-items-center">
                                                            <div className="indicator" style={{ background: `${item.colour}` }}></div>
                                                            <div className="skill-title ml-3">{item.title}<span className="skill-count">{` (${item.incorrectCount})`}</span></div>
                                                        </div>
                                                    </div>
                                                ))
                                                :
                                                <>No Analytical Report</>
                                        }
                                    </div>
                                    {
                                        this.state.caseStudySkillList.length ?
                                            <div className="d-flex justify-content-center mt-5">
                                                <MyPieChart data={this.state.caseStudySkillList} />
                                            </div>
                                            :
                                            <></>
                                    }
                                </div>
                            </div>
                        </div>
                }
            </>
        )
    }
}

export default AssessmentQuote;